import React, { useRef, useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Slider from "react-slick";

import '../home/Home.css';

import '../about/About.css';
import '../experience/Experience.css'
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import hayatin from '../../assets/images/hayatin.jpg';
import homeicon from '../../assets/home-images/homeicon.jpg';
import experienceicon from '../../assets/home-images/experienceicon.jpg';
import plusicon from '../../assets/home-images/plusicon.png';
import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
import videos from '../../assets/home-images/videos.png';
import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
import menu from '../../assets/home-images/menu.png';
import downarrow from '../../assets/home-images/downarrow.png';
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';


//Alternate home page images

import banner7 from '../../assets/home-images/alternate-midsection/Banner7.mp4';
import hayat_preview from "../../assets/home-images/alternate-midsection/2.png";
import hayat_community from "../../assets/home-images/alternate-midsection/9.png";
import leftarrow from '../../assets/offers/leftarrow.png';
import sliderimage1 from "../../assets/home-images/alternate-midsection/3.png";
import sliderimage2 from "../../assets/home-images/alternate-midsection/4.png";
import sliderimage3 from "../../assets/home-images/alternate-midsection/5.png";
import sliderimage4 from "../../assets/home-images/alternate-midsection/ph6.png";
import sliderimage5 from "../../assets/home-images/alternate-midsection/ph7.png";
import sliderimage6 from "../../assets/home-images/alternate-midsection/ph8.png";
import sliderimage7 from "../../assets/home-images/alternate-midsection/ph9.png";

import icon from "../../assets/home-images/alternate-midsection/icon.png";
import icon1 from "../../assets/home-images/alternate-midsection/icon1.png";
import icon2 from "../../assets/home-images/alternate-midsection/icon2.png";
import hayat_commitment from "../../assets/home-images/alternate-midsection/10.png";
import hayat_commitment_1 from "../../assets/home-images/alternate-midsection/10-1.png";
import banner1 from "../../assets/home-images/alternate-midsection/Banner1.png";
import slide1 from "../../assets/home-images/alternate-midsection/7.png";
import slide2 from "../../assets/home-images/alternate-midsection/15.png";
import slide3 from "../../assets/home-images/alternate-midsection/11.png";
import slide4 from "../../assets/home-images/alternate-midsection/12.png";
import slide5 from "../../assets/home-images/alternate-midsection/13.png";
import slide6 from "../../assets/home-images/alternate-midsection/16.png";
import slide7 from "../../assets/home-images/alternate-midsection/8.png";
import qa_image from "../../assets/home-images/alternate-midsection/14.png";
import qa_image1 from "../../assets/home-images/alternate-midsection/ph15.png";
import qa_image2 from "../../assets/home-images/alternate-midsection/ph16.png";
import qa_image3 from "../../assets/home-images/alternate-midsection/ph17.png";

import banner5 from "../../assets/home-images/alternate-midsection/Banner5.png";
import banner2 from "../../assets/home-images/alternate-midsection/Banner2.png";
import banner2_1 from "../../assets/home-images/alternate-midsection/Banner2-1.png";
import banner2_1_1 from "../../assets/home-images/alternate-midsection/Banner2-1-1.png";
import banner2_2 from "../../assets/home-images/alternate-midsection/Banner2-2.png";

import banner4 from "../../assets/home-images/alternate-midsection/Banner4.png";
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";
import bannerbg from "../../assets/home-images/alternate-midsection/bannerbg.png";
import banner1mobile from "../../assets/home-images/alternate-midsection/banner1mobile.png";

import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import ss10 from '../../assets/home-images/alternate-midsection/ss10.png';
import ss11 from '../../assets/home-images/alternate-midsection/ss11.jpg';
import ss12 from '../../assets/home-images/alternate-midsection/ss12.png';
import ss121 from '../../assets/home-images/alternate-midsection/ss12-1.png';

import bs1 from '../../assets/home-images/alternate-midsection/bs1.png';
import bs2 from '../../assets/home-images/alternate-midsection/bs2.png';
import bs3 from '../../assets/home-images/alternate-midsection/bs3.png';
import bs4 from '../../assets/home-images/alternate-midsection/bs4.png';
import bs5 from '../../assets/home-images/alternate-midsection/bs5.png';
import bs6 from '../../assets/home-images/alternate-midsection/bs6.png';
import bs7 from '../../assets/home-images/alternate-midsection/bs7.png';
import bs8 from '../../assets/home-images/alternate-midsection/bs8.png';
import bs9 from '../../assets/home-images/alternate-midsection/bs9.png';
import bs10 from '../../assets/home-images/alternate-midsection/bs10.png';
import bs11 from '../../assets/home-images/alternate-midsection/bs11.png';
import bs12 from '../../assets/home-images/alternate-midsection/bs12.png';
import bs13 from '../../assets/home-images/alternate-midsection/bs13.png';
import bs14 from '../../assets/home-images/alternate-midsection/bs14.png';
import bs15 from '../../assets/home-images/alternate-midsection/bs15.png';



const sliderimagepost = [sliderimage1, sliderimage2, sliderimage3, sliderimage4, sliderimage5, sliderimage6, sliderimage7];
const sliderimagepost1 = [bs1, bs2, bs3, bs4, bs5, bs6, bs7, bs8, bs9, bs10, bs11, bs12, bs13, bs14, bs15];

const faqData = [
    {
        question: "Showcase Your Brand Presence",
        answer: "Build a verified profile that reflects your identity from services and events to stories and posts.",
    },
    {
        question: "Reach Real Audiences",
        answer: "Get discovered by locals and tourists actively exploring what’s trending across the city.",
    },
    {
        question: "Engage and Convert",
        answer: "Post, interact, and measure performance through insights and smart analytics.",
    },
    {
        question: "Collaborate and Feature",
        answer: "Join curated campaigns, seasonal highlights, and city-wide experiences powered by Hayat In.",
    },
];


const About = () => {

    const imagescrollRef = useRef(null);
    const imagescrollRef1 = useRef(null);
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAnswer = (index) => {
        if (openIndex === index) {
            setOpenIndex(null);
        } else {
            setOpenIndex(index);
        }
    };

    // Alter mid section
    // Dynamic slidesToShow function for responsive slider
    const getSlidesToShow = () => {
        const width = window.innerWidth;
        if (width >= 993) return 3;      // Desktop
        if (width >= 769 && width <= 992) return 2;  // Tablet
        if (width >= 320 && width < 769) return 1.5; // Mobile - show 1.5 cards
        return 1; // fallback
    };
    const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());

    useEffect(() => {
        const handleResize = () => setSlidesToShow(getSlidesToShow());
        window.addEventListener("resize", handleResize);

        // Immediately set correct value in case dev tools changed width before render
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [showDots, setShowDots] = useState(window.innerWidth <= 480);
    useEffect(() => {
        const handleResize = () => {
            setShowDots(window.innerWidth <= 480);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const sliderimagesettings = {
        infinite: false,
        slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: showDots,
        swipe: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll: 1
                }
            }
        ],
    };

    const sliderimagesettings1 = {
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: false,
        swipe: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                }
            },
        ],
    };

    return (
        <div>
            <Navbar />


            <div className="experience-main-layout">
                <LeftSection />


                <main className="experience-middle-section">
                    <div className="alter-mid-center-video">
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline className="video">
                            <source src={banner7} type="video/mp4" />
                        </video>
                        <div className="bannerbg-overlay-content">
                            <div className="alter-mid-center-text">The Hayat In App</div>
                            <p className="alter-mid-center-sub-head">A smarter way to discover, plan, and experience the city.</p>
                            <p className="alter-mid-center-para">
                                Hayat In brings places, offers, events, and experiences together in one intelligent app so exploring the city feels natural, relevant, and effortless.                            </p>
                            <div className="store-buttons-overlay">
                                <a
                                    href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={app_store} alt="App Store" />
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={play_store} alt="Google Play" />
                                </a>
                            </div>
                        </div>

                    </div>

                    <div className="story-content">
                        <div className="story-left">
                            <h2>Explore <br></br><span className="highlight">What’s Happening Now</span></h2>
                            <p>
                                The app shows what’s trending across the city in real time—based on activity, timing, and location.
                                Instead of outdated lists or random suggestions, you see what matters right now.
                            </p>
                        </div>
                        <div className="story-right">
                            <img src={hayat_preview} alt="Hayat In Preview" />
                        </div>
                    </div>

                    {/* <!-- HAYAT IN COMMUNITY SECTION --> */}

                    <div className="community-content">
                        <div className="community-left">
                            <img src={hayat_community} alt="Hayat In Community" className="community-img" />
                        </div>


                        <div className="community-right">
                            {/* <h2>The Vision</h2> */}
                            <h3>Plan Your Day with <span>Intelligence</span></h3>
                            <p>
                                Hayat In moves beyond outdated digital tools to pioneer a unified environment where discovery, engagement, and
                                growth happen naturally.
                            </p>
                            <p>
                                It’s purpose-built for clarity, precision, and genuine connection between businesses and communities,
                                redefining how visibility and communication work in a local-first world.
                            </p>
                            <p>
                                By blending technology with human context, Hayat In creates a smarter ecosystem where brands tell their
                                stories, audiences engage in real time, and cities become more connected than ever.
                            </p>
                        </div>
                    </div>

                    <div className="designed-content">
                        <h2>Discover and Act in <span className="highlight1">One Flow</span></h2>
                        <p>
                            Every experience in Hayat In is designed to move smoothly from discovery to action.
                            Explore a place or event, understand it instantly, then call, message, navigate, or book all within the same journey.
                        </p>
                    </div>

                    <div className="image-scroll-wrapper">
                        <img src={leftarrow} alt="left arrow" className="arrows-aboutpage arrows-left" onClick={() => imagescrollRef.current.slickPrev()} />
                        <div className="image-scroll">
                            <Slider ref={imagescrollRef} {...sliderimagesettings}>
                                {sliderimagepost.map((item, index) => (
                                    <div className="image-scroll-carousel" key={index}>
                                        <img src={item} alt="image-scroll-item" id="aboutpage-carousel1-img" />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                        <img src={rightarrow} alt="right arrow" className="arrows-aboutpage arrows-right" onClick={() => imagescrollRef.current.slickNext()} />
                        <div className="arrows-container-mobile">
                            <img src={leftarrow} alt="left arrow" className="arrows-aboutpage-left" onClick={() => imagescrollRef.current.slickPrev()} />
                            <img src={rightarrow} alt="right arrow" className="arrows-aboutpage-right" onClick={() => imagescrollRef.current.slickNext()} />
                        </div>
                    </div>



                    {/* <div className="ai-content">
                        <h2>Powered by AI. Designed for Real Life.</h2>
                        <p>Where Artificial Intelligence Meets <br /> Real-Life Experiences.</p>
                        <p className="p1">At Hayat In, we’re redefining what social commerce means in the age of intelligence.</p>
                    </div>

                    <div className="ai-features">
                        <div className="feature">
                            <img src={icon} alt="AI Understands Icon" />
                            <p>Our AI doesn’t just recommend, it understands. It learns what users love, what they need, where they go, and
                                what inspires them, turning everyday scrolling into curated, meaningful discovery.</p>
                        </div>

                        <div className="feature">
                            <img src={icon1} alt="AI Growth Icon" />
                            <p>For businesses, AI becomes your growth partner, predicting demand, analyzing engagement, and helping you reach
                                the right audience at the right moment. From smarter visibility to data-driven insights, Hayat In empowers
                                providers to make every interaction count.</p>
                        </div>

                        <div className="feature">
                            <img src={icon2} alt="Connected Ecosystem Icon" />
                            <p>We’re building a connected ecosystem where technology bridges people, places, and possibilities. Together,
                                we’re shaping a future where discovery is personal, business is smarter, and every experience feels made for
                                you.</p>
                        </div>
                    </div> */}

                    <div className="commitment-section">
                        <div className="story-right">
                            <img src={hayat_commitment_1} alt="Our Commitment" id="commitmentimg" />
                        </div>
                        <div className="text-side">
                            <h2>Search <span>Naturally</span></h2>
                            <p>
                                Search the way you think:
                                “Best dinner nearby.” “Things to do today.” “Weekend plans.”<br></br><br></br><br></br>

                                Hayat In instantly finds relevant places, offers, and events without complicated filters.
                            </p>
                        </div>

                    </div>

                    <div className="banner1-text-in-mobile-view">
                        <h5>A Living View of the <span>City</span></h5>
                        <h6>Hayat In reflects the city as it moves.</h6>
                        <p>What you see is always current: Active places, Live offers,  Ongoing events
                            Each visit feels fresh, relevant, and connected to what’s happening around you.
                        </p>
                    </div>

                    <div className="banner1-only" style={{ backgroundImage: `url(${banner1})` }}></div>
                    <div className="text-content">
                        <h2>Bringing You Closer To <br /> Things You <span class="highlight"> Love </span></h2>
                        <p>Stay updated with fresh content, exclusive offers, and dynamic interactions.</p>
                    </div>


                    <div className="image-scroll-wrapper1">
                        <img src={leftarrow} alt="left arrow" className="arrows-aboutpage" onClick={() => imagescrollRef1.current.slickPrev()} />
                        <div className="image-scroll1">
                            <Slider ref={imagescrollRef1} {...sliderimagesettings1}>
                                {sliderimagepost1.map((item, index) => (
                                    <div className="image-scroll-card1" key={index}>
                                        <div className="image-scroll-carousel1">
                                            <img src={item} alt="image-scroll-item1" />
                                        </div>
                                    </div>

                                ))}
                            </Slider>
                        </div>
                        <img src={rightarrow} alt="right arrow" className="arrows-aboutpage" onClick={() => imagescrollRef1.current.slickNext()} />
                    </div>

                    <div className="text-left">
                        <h2>More Than a Listing App</h2>
                        <h4>Hayat In is not just a directory or a deals app</h4>
                        <p> It’s a city experience engine—designed to help people make better decisions, faster, and experience more of what the city has to offer.</p>
                    </div>


                    <div className="qa-section">
                        <div className="left-side">
                            <img
                                src={
                                    openIndex === 0 ? qa_image :
                                        openIndex === 1 ? qa_image1 :
                                            openIndex === 2 ? qa_image2 :
                                                openIndex === 3 ? qa_image3 :
                                                    qa_image
                                }
                                alt="Section"
                                className="qa-img"
                            />
                        </div>

                        <div className="accordion">
                            {faqData.map((item, index) => {
                                const qaImages = [qa_image, qa_image1, qa_image2, qa_image3];
                                return (
                                    <div className="accordion-item" key={index}>
                                        <div className="question" onClick={() => toggleAnswer(index)}>
                                            <span>{item.question}</span>
                                            <span className={`arrow ${openIndex === index ? "open" : ""}`}>
                                                &#9662;
                                            </span>
                                        </div>
                                        {openIndex === index && (
                                            <div className="answer">
                                                <p>{item.answer}</p>
                                                <div className="answer-image-mobile">
                                                    <img
                                                        src={qaImages[index] || qa_image}
                                                        alt={item.question}
                                                        className="qa-answer-img"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="explore-section">
                        <h2>From Lifestyle to Corporate, We’ve Got You Covered</h2>
                        <p>Showcase your business where the city scrolls, searches, and decides.</p>
                    </div>

                    <div className="explore-section">
                        <h2>From Lifestyle to Corporate, We’ve Got You Covered</h2>
                        <p>Showcase your business where the city scrolls, searches, and decides.</p>
                    </div>

                    <div className="banner5-only">
                        <img src={banner5} className="banner5" alt="banner5 only" />
                    </div>

                    <div className="centered-banner">
                        <img src={banner2} alt="Banner 2" className="banner2-desktop" />
                        <div className="banner2-mobile">
                            <img src={banner2_1} alt="Banner 2 Part 1" className="banner2-mobile-img" />
                            <img src={banner2_1_1} alt="Banner 2 Part 1" className="banner2-1-1-mobile-img" />

                            <img src={banner2_2} alt="Banner 2 Part 2" className="banner2-mobile-img" />
                        </div>
                    </div>

                    <div className="banner4">
                        <img src={banner4} alt="Banner 4" />
                    </div>
                </main>

            </div>
        </div>

    )
}

export default About